import { z } from 'zod';
import { defineEndpoint } from '../define';

export const WorkflowInputMetaSchema = z.object({
  name: z.string(),
  required: z.boolean(),
  /** Raw GitHub input type: string | boolean | number | choice | environment. */
  type: z.string(),
  default: z.string(),
  /** '' when the input declares no description. */
  description: z.string(),
  /** Non-empty only for `type: choice` — GitHub allows `options` on no other type. */
  options: z.array(z.string()),
});
export type WorkflowInputMeta = z.infer<typeof WorkflowInputMetaSchema>;

/** Parsed metadata for one workflow file at a ref. */
export const WorkflowFileMetaSchema = z.object({
  file: z.string(),
  /** Whether the file declares `on: workflow_dispatch`. */
  dispatchable: z.boolean(),
  inputs: z.array(WorkflowInputMetaSchema),
  /** Non-null when the YAML could not be parsed. */
  error: z.enum(['parse_error']).nullable(),
});
export type WorkflowFileMeta = z.infer<typeof WorkflowFileMetaSchema>;

/**
 * A browse row = parsed file metadata + whether GitHub has the workflow
 * registered (a file only on a non-default branch is not dispatchable yet).
 */
export const GitWorkflowRowSchema = WorkflowFileMetaSchema.extend({
  registered: z.boolean(),
});
export type GitWorkflowRow = z.infer<typeof GitWorkflowRowSchema>;

/** Workflow files under .github/workflows at the given ref (usually the pinned SHA), with dispatch metadata. */
export const listGitWorkflows = defineEndpoint({
  method: 'GET',
  path: '/v1/release-products/:productId/git/workflows',
  params: z.object({ productId: z.string().uuid() }),
  query: z.object({ ref: z.string().min(1) }),
  body: z.undefined(),
  response: z.object({ data: z.array(GitWorkflowRowSchema) }),
});
